var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMentorSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "la:chalkboard-teacher"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.625 8.9375V11.75H36.5625V34.25H16.875V37.0625H42.1875V34.25H39.375V8.9375H5.625ZM11.2528 13.1562C9.76231 13.1614 8.33429 13.7556 7.28007 14.8093C6.22585 15.863 5.63093 17.2907 5.625 18.7812C5.625 21.8736 8.16187 24.4062 11.2528 24.4062C12.7426 24.4003 14.1696 23.8057 15.2227 22.752C16.2759 21.6983 16.8698 20.271 16.875 18.7812C16.875 15.6917 14.3409 13.1562 11.2528 13.1562ZM19.6875 14.5625V17.375H26.7188V14.5625H19.6875ZM29.5312 14.5625V17.375H33.75V14.5625H29.5312ZM11.2528 15.9688C12.8194 15.9688 14.0625 17.2105 14.0625 18.7812C14.0625 20.3562 12.8208 21.5938 11.2528 21.5938C9.67781 21.5938 8.4375 20.3562 8.4375 18.7812C8.4375 17.2105 9.67922 15.9688 11.2528 15.9688ZM19.6875 20.1875V23H33.75V20.1875H19.6875ZM5.625 25.8125V37.0625H8.4375V28.625H12.6562V37.0625H15.4688V29.5503L18.3713 31.0859C19.1939 31.5219 20.1825 31.5205 21.0037 31.0859V31.0888L25.9678 28.4633L24.6558 25.9742L19.6903 28.5997L15.3366 26.3019C14.7289 25.9809 14.0522 25.8129 13.365 25.8125H5.625Z",
    fill: "#4555BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorSupport);
export default __webpack_public_path__ + "static/media/mentorSupport.1b8acaf5bcd46bf7847a5ca049e0f0ac.svg";
export { ForwardRef as ReactComponent };